<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="content-page-header">
          <h5>
            <router-link to="/customers" style="color: #28084b">
              <i class="feather feather-arrow-left me-1"></i> </router-link
            >Edit Customer
          </h5>
        </div>

        <div class="row">
          <div class="col-md-12">
            <b-form @submit="onSubmit">
              <div class="card-body">
                <div class="form-group-item">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="billing-btn mb-2">
                        <h5 class="form-title">Basic Information</h5>
                      </div>
                      <div class="form-group">
                        <label>Full Name</label>
                        <b-form-input
                          type="text"
                          class="form-control"
                          v-model="form.name"
                          placeholder="Enter Name"
                          required
                        />
                      </div>
                      <div class="form-group">
                        <label>Email</label>
                        <b-form-input
                          type="text"
                          v-model="form.email"
                          class="form-control"
                          placeholder="Enter Your Email"
                          required
                        />
                      </div>
                      <div class="form-group">
                        <label>Phone</label>
                        <input
                          type="tel"
                          v-model="form.phone"
                          @input="getFormattedNumber"
                          ref="phoneInputRef"
                          class="form-control"
                          id="phone"
                          placeholder="Your phone number"
                        />
                      </div>
                      <div class="form-group mb-0">
                        <label class="custom_check me-3" style="color: #878a99">
                          <input
                            type="checkbox"
                            @click="OpenWat"
                            v-model="useforwhatsapp"
                            name="whatsapp"
                          />
                          <span class="checkmark"></span> Use for WhatsApp
                        </label>
                      </div>
                      <div class="form-group" v-if="!useforwhatsapp">
                        <label>WhatsApp Number</label>
                        <input
                          type="tel"
                          v-model="form.whatsapp_number"
                          @input="getFormattedWhatsappNumber"
                          ref="whatsappInputRef"
                          class="form-control"
                          id="phone"
                          placeholder="Your WhatsApp number"
                        />
                      </div>
                      <div class="form-group notes-form-group">
                        <label>Address</label>
                        <textarea
                          class="form-control"
                          v-model="form.address"
                          placeholder="Enter Your Address"
                        ></textarea>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group">
                            <label>Website</label>
                            <b-form-input
                              type="text"
                              v-model="form.website"
                              class="form-control"
                              placeholder="Enter Your website"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group">
                            <label>Category</label>
                            <b-form-select
                              class="form-select"
                              v-model="form.category"
                            >
                              <b-form-select-option disabled value=""
                                >Category</b-form-select-option
                              >
                              <b-form-select-option
                                v-for="(category, index) in categories"
                                :key="index"
                                :value="category"
                              >
                                {{ category }}
                              </b-form-select-option>
                            </b-form-select>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group">
                            <label>Country</label>
                            <b-form-select
                              class="form-control"
                              v-model="form.country"
                            >
                              <b-form-select-option :value="null"
                                >Your country</b-form-select-option
                              >
                              <b-form-select-option
                                v-for="(country, index) in Countries"
                                :key="index"
                                :value="country.isoCode"
                                >{{ country.name }}</b-form-select-option
                              >
                            </b-form-select>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group">
                            <label>State</label>
                            <b-form-select
                              class="form-control"
                              v-model="form.state"
                            >
                              <b-form-select-option :value="null"
                                >Your state</b-form-select-option
                              >
                              <b-form-select-option
                                v-for="(state, index) in States"
                                :key="index"
                                :value="state.name"
                                >{{ state.name }}</b-form-select-option
                              >
                            </b-form-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="add-customer-btns text-end">
                  <router-link
                    to="/customers"
                    href="javascript:;"
                    type="reset"
                    class="btn customer-btn-cancel"
                    >Cancel</router-link
                  >
                  <b-button
                    :disabled="isLoading"
                    type="submit"
                    variant="primary"
                  >
                    <span
                      v-if="isLoading"
                      class="spinner-border spinner-border-sm me-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span v-if="!isLoading">Save Changes</span>
                    <span v-if="isLoading">Updating...</span>
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Country, State } from "country-state-city";

const Countries = ref(null);
const isLoading = ref(false);
const store = useStore();
const route = useRoute();
const categories = ["Business", "Agriculture", "Finance", "Education"];
const useforwhatsapp = ref(true);
const phoneInputRef = ref(null);
const whatsappInputRef = ref(null);
let iti;

const form = ref({
  name: "",
  address: "",
  email: "",
  phone: "",
  whatsapp_number: "",
  website: "",
  address: "",
  category: "",
  country: null,
  state: null,
});

watch(useforwhatsapp, (newValue) => {
  if (newValue === true) {
    form.value.whatsapp_number = "";
  }
});

// Formating the phone number
const getFormattedNumber = () => {
  if (iti) {
    const formattedNumber = iti.getSelectedCountryData();
    form.value.country_code = `+${formattedNumber.dialCode}`;

    const firstDigit = form.value.phone.charAt(0);
    if (
      form.value.phone.length === 11 &&
      firstDigit != "+" &&
      firstDigit == "0"
    ) {
      form.value.phone = `${form.value.phone.slice(1)}`;
    } else if (form.value.phone.length === 11 && firstDigit != "+") {
      form.value.phone = `${form.value.phone}`;
    }
  }
};

// Formating the whatsapp number
const getFormattedWhatsappNumber = () => {
  if (iti) {
    const formattedNumber = iti.getSelectedCountryData();

    const firstDigit = form.value.whatsapp_number.charAt(0);
    if (
      form.value.whatsapp_number.length === 11 &&
      firstDigit != "+" &&
      firstDigit == "0"
    ) {
      form.value.whatsapp_number = `${form.value.whatsapp_number.slice(1)}`;
    } else if (form.value.whatsapp_number.length === 11 && firstDigit != "+") {
      form.value.whatsapp_number = `${form.value.whatsapp_number}`;
    }
  }
};

const States = computed(() => {
  return State.getStatesOfCountry(form.value.country);
});

const getCustomer = () => {
  store.dispatch("customer/getCustomer", route.params.id).then(() => {
    form.value = customer.value;
    if (customer.value.phone === customer.value.whatsapp_number) {
      useforwhatsapp.value = true;
    } else {
      useforwhatsapp.value = false;
    }
  });
};

const customer = computed(() => {
  return store.getters["customer/mycustomer"];
});

const onSubmit = () => {
  if (useforwhatsapp.value == true) {
    form.value.whatsapp_number = form.value.phone;
  }
  isLoading.value = true;
  let data = {
    id: route.params.id,
    payload: form.value,
  };
  store
    .dispatch("customer/editCustomer", data)
    .then(() => {
      isLoading.value = false;
    })
    .catch(() => {
      isLoading.value = false;
    });
};

onMounted(() => {
  getCustomer();
  Countries.value = Country.getAllCountries();

  iti = intlTelInput(phoneInputRef.value, {
    nationalMode: true,
    autoPlaceholder: "aggressive",
    formatOnDisplay: true,
    autoInsertDialCode: true,
    separateDialCode: true,
  });

  fetch("https://ipapi.co/json/")
    .then((response) => response.json())
    .then((data) => {
      const countryCode = data.country_code;
      iti.setCountry(countryCode);
    })
    .catch((error) => {
      console.error("Error fetching IP data:", error);
    });
});
</script>
